import { Donor } from './donor';
import { Recipient } from './recipient';
import { MatchingPeriod } from './matchingPeriod';

export interface Pair {
  id: string;
  matchingPeriod?: MatchingPeriod;
  recipient: Recipient;
  donor: Donor;
  matchingPeriodCount?: number;
  active: boolean;
  compatible: boolean;
  reasonInactive?: string;
  /** Set by the backend: inactive only because the recipient is inactive (group). */
  inactiveByRecipient?: boolean;
  comments?: string;
  relationToRecipient?: string;
  reasonForRemoval?: string;
  /** Request to add a newly created pair to the current matching period (create only). */
  addToMatchingPeriod?: boolean;

  // Historical status
  historical?: boolean;
  historicalDate?: string;
  historicalReason?: string;
}

export enum ReasonInactive {
  NewMatchingPeriod = 'New matching period',
  AwaitingNewMatchRunPeriod = 'Awaiting new match run period',
  NotIncludedInMinimatch = 'Not included in minimatch',
  SelectedForTransplant = 'Selected for transplant',
  MedicalProblemsPatient = 'Medical problems patient',
  MedicalProblemsDonor = 'Medical problems donor',
  PhychologicalProblemsPatient = 'Psychological problems patient',
  PhychologicalProblemsDonor = 'Psychological problems donor',
  LockedChain = 'Member of a locked chain', // pair is part of a locked chain,
  Other = 'Other' // Any other reason not listed above
}
